"use strict";
exports.__esModule = true;
exports.fontWeight = exports.lineHeight = exports.fontSize = void 0;
exports.fontSize = {
    100: 9,
    200: 10,
    300: 11,
    400: 12,
    500: 14,
    600: 16,
    700: 24,
    800: 36
};
exports.lineHeight = {
    100: 13.5,
    200: 15,
    300: 16.5,
    400: 18,
    500: 21,
    600: 24,
    700: 34,
    800: 54
};
exports.fontWeight = {
    normal: 'normal',
    bold: 'bold',
    100: '100',
    200: '200',
    300: '300',
    400: '400',
    500: '500',
    600: '600',
    700: '700',
    800: '800',
    900: '900'
};
